import { ContactDepartmentEditForm } from 'application/contact-department/forms';
import {BaseEditViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import {ContactDepartmentService} from 'application/contact-department/services';
import { action, observable, runInAction } from 'mobx';
import { LookupService } from "common/services";

@applicationContext
class ContactDepartmentEditViewStore extends BaseEditViewStore {
    @observable accessor contactDepartmentTypes = [];
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new ContactDepartmentService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'role',
            id: id,
            Form: ContactDepartmentEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                   get: async (id) => {
                        const response = await service.get(id, { embed: 'ContactDepartmentType' });
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
    
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ContactDepartmentEditForm,
        });
    } 

    @action
    async initialize() {
        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        const lookups = await lookupService.getLookups('ContactDepartmentType');
        runInAction(() => {
            this.contactDepartmentTypes = lookups.contactDepartmentType;
        });

        if (this.isEdit) {
            await this.getResource(this.id);
        } else {
            this.form.clear();
        }
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('CONTACT_DEPARTMENT.CREATE.SUCCESS');
    }
    
    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('CONTACT_DEPARTMENT.EDIT.SUCCESS', name);
    }
}

export default ContactDepartmentEditViewStore;